import { Suspense } from 'react';
import { createFileRoute } from '@tanstack/react-router';
import { ErrorBoundary } from '@/components/common/ErrorBoundary';
import { PageLoader } from '@/components/common/PageLoader';
import { PcmpRequestCategoriesPage } from '@/features/pcmp/pages/PcmpRequestCategoriesPage';

export const Route = createFileRoute('/_auth/pcmp/request-categories/')({
  component: () => (
    <ErrorBoundary moduleName="PCMP Request Categories">
      <Suspense fallback={<PageLoader />}>
        <PcmpRequestCategoriesPage />
      </Suspense>
    </ErrorBoundary>
  ),
});
